
let url = require('url');

export default class baseApi {
    private _baseUrl: string;
    private _userId: string;

    constructor(baseUrl: string, userId: string) {
        this._baseUrl = baseUrl;
        this._userId = userId;
    }

    public async Post(path: string, object: object) {
        let response: Response;

        try {
            let urlPath = url.resolve(this._baseUrl, path);

            response = await fetch(urlPath, {
                method: 'POST',
                body: JSON.stringify(object),
                headers: {
                    'EditOnBehalfOfUserGuid': this._userId,
                    'TenantId': this._userId,
                    'Content-Type': 'application/json;charset=utf-8',
                }
            });

            if (response.status !== 200)
                throw Error(`POST failed: ${path} - ${response.status} (${await response.text()})`);

        } catch (error) {
            console.log(error);
            throw error;
        }

        let message = await response.text();

        return message ? JSON.parse(message) : {};
    }

    public async Get(path: string) {
        let response: Response;

        try {
            let urlPath = url.resolve(this._baseUrl, path);

            response = await fetch(urlPath, {
                headers: {
                    'EditOnBehalfOfUserGuid': this._userId,
                    'TenantId': this._userId,
                }
            });

            if (!(response.status === 200 || response.status === 204))
                throw Error(`GET failed: ${path} - ${response.status} (${await response.text()})`);

        } catch (error) {
            console.log(error);
            throw error;
        }

        let message = await response.text();

        return message ? JSON.parse(message) : {};
    }
}